<template>
  <div class="roleLogin_container">
    <div class="roleLogin_block">
      <img
        :src="require('@/assets/images/live/sign.png')"
        class="roleLogin_banner"
      />
      <div class="roleLogin_btn">
        <div class="roleLogin_btn_row">
          <span style="font-weight: bold; color: #333f48">我是志愿者</span>
          <CustomButton class="submit-btn" @click="goToLogin('admin')">
            点击登录</CustomButton
          >
        </div>
        <div class="roleLogin_btn_row">
          <span style="font-weight: bold; color: #333f48">我是专家</span>
          <CustomButton class="submit-btn" @click="goToLogin('doctor')">
            点击登录</CustomButton
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CustomButton from "@/components/unit/CustomButton";
export default {
  name: "roleLogin",
  components: {
    CustomButton,
  },
  data() {
    return {
      loading: false,
    };
  },

  created() {
    this.$nextTick(() => {
      document.body.addEventListener("contextmenu", this.$tools.noScroll);
    });
  },
  beforeUnMount() {
    document.body.removeEventListener("contextmenu", this.$tools.noScroll);
  },
  methods: {
    imgLoading(event) {
      console.log("图片加载成功", event.target);
      this.loading = true;
    },
    goToLogin(type) {
      let url = "";
      switch (type) {
        case "admin":
          url = `${this.$config.host}/#/login`;
          break;
        case "doctor":
          url = `${this.$config.host}/#/doctorLogin`;
          break;
      }
      window.location.href = url;
    },
  },
};
</script>
<style>
.roleLogin_container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: url("~@/assets/images/live/bg.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
}

.roleLogin_banner {
  width: 5rem;
  object-fit: contain;
  margin-bottom: 0.25rem;
}
.roleLogin_block {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 75%;
  height: 50vh;
  background: rgba(255, 255, 255, 0.3);
  padding: 0.05rem;
  position: relative;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
}

.roleLogin_tips {
  width: 100%;
  height: 100%;
  border-radius: 0 0 0.4rem 0.4rem;
}
.roleLogin_btn {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 1.5rem 0;
  padding: 0 0.75rem;
}
.submit-btn {
  color: #fff;
  background: #c12822;
  height: 1rem !important;
  font-size: 0.5rem;
  border-radius: 1rem;
  padding: 0 0.175rem;
  width: 3rem !important;

  margin-left: 0.5rem;
}

.goIcon {
  width: 0.5rem;
  height: 0.5rem;
  margin-right: 0.4rem;
}
.roleLogin_tips_block {
  font-size: 0.4rem;
  color: #8c8c8b;
  position: absolute;
  bottom: 0.5rem;
}
.roleLogin_tips_desc {
  display: flex;
  align-items: center;
}
.roleLogin_tips_desc:last-child {
  margin-top: 0.25rem;
}
.round {
  width: 0.15rem;
  height: 0.15rem;
  border-radius: 50%;
  background: #8c8c8b;
  margin-right: 0.1rem;
}
.roleLogin_btn_row {
  background: #f2f2f2;
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 1rem;
  margin-bottom: 1rem;
  padding-left: 0.5rem;
  font-size: 0.5rem;
  white-space: nowrap;
  background: #fce6e2;
}
.roleLogin_btn_row .date {
  color: #c12822;
  font-weight: bolder;
  border-bottom: 1px solid #c12822;
}
</style>
